import {
  TOGGLE_PLANS_LOADING,
  TOGGLE_PLANS_SUCCESS,
  TOGGLE_PLANS_FAILED,
} from "../types";
import { Plan } from "../../models/Plan";

interface PlansState {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: PlansState = {
  plans: [],
  loading: false,
  error: null,
  success: false,
};

type Action =
  | { type: typeof TOGGLE_PLANS_LOADING }
  | { type: typeof TOGGLE_PLANS_SUCCESS; payload: Plan[] }
  | { type: typeof TOGGLE_PLANS_FAILED; payload?: string };

export const togglePlansReducer = (
  state = initialState,
  action: Action
): PlansState => {
  switch (action.type) {
    case TOGGLE_PLANS_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case TOGGLE_PLANS_SUCCESS: {
      const updatedPlans = action.payload;
      const updatedPlanIds = new Set(updatedPlans?.map((p) => p.id));

      return {
        ...state,
        loading: false,
        error: null,
        plans: [
          ...state.plans
            .filter((plan) => !updatedPlanIds.has(plan.id))
            .concat(updatedPlans),
        ],
        success: true,
      };
    }
    case TOGGLE_PLANS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to toggle plans",
        success: false,
      };

    default:
      return state;
  }
};
